import { TEMPLATE_ERROR_SHOW, TEMPLATE_ERROR_CLOSE, TEMPLATE_SPINNER_SHOW, TEMPLATE_SPINNER_HIDE, APP_CHECK_ACTIONS, LOAD_APP_CONFIG_SUCCESS, SAVE_USER_PARAMS, SAVE_DIMENSION, SET_NAVIGATE_TO, RESET_NAVIGATE_TO, CART_ITEMS_LIST_NAME, SET_HAND_IT_TO_ME_STATUS, SET_HEADER_TITLE, TAB_REFRESH, } from '../../constants';
const initialState = {
    showLoader: false,
    showMessage: false,
    locationEnabled: false,
    androidVersion: '1.0.0',
    iosVersion: '1.0.0',
    dispositions: [],
    saved: false,
    bucketProperty: {},
    userStatus: {
        loggedIn: false,
        localized: false,
    },
    isHandItToMeSelected: false,
    headerTitle: '',
    refresh: false,
};
const appStateReducer = (state = initialState, action) => {
    switch (action.type) {
        case TEMPLATE_ERROR_SHOW:
            return {
                ...state,
                showError: true,
            };
        case TEMPLATE_ERROR_CLOSE:
            return {
                ...state,
                showError: false,
            };
        case TEMPLATE_SPINNER_SHOW:
            return {
                ...state,
                showSpinner: true,
            };
        case TEMPLATE_SPINNER_HIDE:
            return {
                ...state,
                showSpinner: false,
            };
        case APP_CHECK_ACTIONS:
            return {
                ...state,
                locationEnabled: action.locationEnabled,
            };
        case LOAD_APP_CONFIG_SUCCESS:
            return {
                ...state,
                response: action.config,
            };
        case SAVE_USER_PARAMS:
            return {
                ...state,
                userStatus: {
                    ...state.userStatus,
                    ...action?.response,
                },
                saved: true,
            };
        case SAVE_DIMENSION:
            return {
                ...state,
                bucketProperty: action.response,
            };
        case SET_NAVIGATE_TO:
            return {
                ...state,
                screenName: action.screenName,
            };
        case CART_ITEMS_LIST_NAME:
            return {
                ...state,
                cartListName: action.listName,
            };
        case RESET_NAVIGATE_TO:
            return {
                ...state,
                screenName: '',
            };
        case SET_HEADER_TITLE:
            return {
                ...state,
                headerTitle: action.headerTitle,
            };
        case SET_HAND_IT_TO_ME_STATUS:
            return {
                ...state,
                isHandItToMeSelected: action.isHandItToMeSelected,
            };
        case TAB_REFRESH:
            return {
                ...state,
                refresh: action.refresh,
            };
        default:
            return state;
    }
};
export default appStateReducer;
